// assets/ajaxFlavorSwitcher.js.liquid

(function () {
  const productInfo = document.querySelector('product-info');
  const vendor = productInfo.getAttribute('data-vendor');
  const currentHandle = productInfo.getAttribute('data-handle');
  const productType = productInfo.getAttribute('data-product-type');
  
  const shouldRenderDropdown = ["Disposable", "E-Liquid", "Nitocine Pouches"].includes(productType);
  
  fetchVendorProducts(vendor, currentHandle, productType);
  if (shouldRenderDropdown && vendor && !document.getElementById('flavor-select')) {
  }

  document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
      const select = document.getElementById('flavor-select');
      if (select) {
        setupAjaxFlavorSwitcher(select);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  async function fetchVendorProducts(vendor, currentHandle, productType) {
    const response = await fetch('https://get-pop.myshopify.com/api/2024-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '00b72c900d69551318d27bfc65a26879'
      },
      body: JSON.stringify({
        query: `query getProducts($query: String!) {
          products(first: 50, query: $query) {
            edges {
              node {
                title
                handle
                vendor
                variants(first: 1) {
                  edges {
                    node {
                      availableForSale
                    }
                  }
                }
              }
            }
          }
        }`,
        variables: { query: `vendor:"${vendor}" AND product_type:"${productType}"` }
      })
    });

    const data = await response.json();
    const products = data.data.products.edges.map(edge => {
                      return {
                        title: edge.node.title,
                        handle: edge.node.handle,
                        vendor: edge.node.vendor,
                        available: edge.node.variants.edges[0]?.node.availableForSale
                      };
                     }).filter(product => product.vendor === vendor);
    //  Sort products alphabetically by title
    products.sort((a, b) => a.title.localeCompare(b.title));
    if (!products.length) return;

    const container = document.getElementById('vendor-dropdown');
    if (!container) return;
    container.innerHTML = '';
    container.style.display = 'flex';
    container.style.gap = '4px';

    const dropdown = document.createElement('div');
    dropdown.className = 'custom-dropdown';
    dropdown.style.position = 'relative';
    dropdown.style.width = '100%';

    const label = document.createElement('label');
    label.setAttribute('for', 'flavor-select');
    label.textContent = 'Flavor';
    label.style.flex = '0 0 30%';
    label.style.fontWeight = '600';
    label.style.display = 'flex';
    label.style.alignItems = 'center';

    const toggle = document.createElement('button');
    toggle.className = 'dropdown-toggle';
    toggle.textContent = products.find(p => p.handle === currentHandle)?.title || 'Select Flavor';
    toggle.style.fontSize = '16px';
    toggle.style.border = '1px solid #000';
    toggle.style.borderRadius = '8px';
    toggle.style.minHeight = 'var(--buttons-height)';
    toggle.style.backgroundColor = '#fff';
    toggle.style.display = 'flex';
    toggle.style.alignItems = 'center';
    toggle.style.justifyContent = 'space-between';
    toggle.style.gap = '8px';
    toggle.style.paddingRight = '32px'; // Leave space for chevron
    toggle.style.paddingLeft = '1rem';  // Leave space for chevron
    toggle.style.width = '100%';        // Leave space for chevron
    toggle.style.position = 'relative';
    toggle.innerHTML = `${toggle.textContent}
      <span style="position: absolute; right: 12px; pointer-events: none; display: flex; align-items: center;">
        <svg fill="none" height="16" viewBox="0 0 32 32" width="16" xmlns="http://www.w3.org/2000/svg">
          <path clip-rule="evenodd" d="M4.93934 10.9393c.58579-.5857 1.53553-.5857 2.12132 0l8.93934 8.9394 8.9393-8.9394c.5858-.5857 1.5356-.5857 2.1214 0 .5857.5858.5857 1.5356 0 2.1214l-10 10c-.5858.5857-1.5356.5857-2.1214 0l-9.99996-10c-.58579-.5858-.58579-1.5356 0-2.1214z" fill="rgb(0,0,0)" fill-rule="evenodd"></path>
        </svg>
      </span>
    `;

    const list = document.createElement('ul');
    list.id = 'flavor-list';
    list.className = 'dropdown-menu';
    list.style.position = 'absolute';
    list.style.top = '100%';
    list.style.left = '0';
    list.style.right = '0';
    list.style.backgroundColor = '#fff';
    list.style.border = '1px solid #000';
    list.style.borderRadius = '6px';
    list.style.margin = '4px 0 0 0';
    list.style.padding = '0';
    list.style.listStyle = 'none';
    list.style.maxHeight = '250px';
    list.style.overflowY = 'auto';
    list.style.zIndex = '1000';
    list.style.display = 'none';

    products.forEach(product => {
      const li = document.createElement('li');

      const link = document.createElement('a');
      link.href = `/products/${product.handle}`;
      link.textContent = product.available ? product.title : `${product.title} (Out of Stock)`;
      link.dataset.handle = product.handle;

      link.style.display = 'block';
      link.style.padding = '8px 12px';
      link.style.textDecoration = 'none';
      link.style.color = '#000';
      link.style.borderBottom = '1px solid #eee';

      if (product.handle === currentHandle) {
        link.style.fontWeight = 'bold';
        link.style.backgroundColor = '#000';
        link.style.color = '#fff';
        link.style.pointerEvents = 'none';
      } else if (!product.available) {
        link.style.color = '#999';
        link.style.fontStyle = 'italic';
      }

      li.appendChild(link);
      list.appendChild(li);
    });

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      list.style.display = list.style.display === 'none' ? 'block' : 'none';
    });

    document.addEventListener('click', () => {
      list.style.display = 'none';
    });

    dropdown.appendChild(toggle);
    dropdown.appendChild(list);
    container.appendChild(label);
    container.appendChild(dropdown);

    setupAjaxFlavorSwitcher(list);
  }

  function setupAjaxFlavorSwitcher(listContainer) {
    listContainer.addEventListener('click', async function (e) {
      if (e.target.tagName.toLowerCase() !== 'a') return;
      e.preventDefault();

      const newUrl = e.target.href;
      try {
        const response = await fetch(newUrl);
        const html = await response.text();
        const newDoc = new DOMParser().parseFromString(html, 'text/html');
        updateProductContent(newDoc);
        document.title = newDoc.title;
        window.history.pushState({}, '', newUrl);
      } catch (error) {
        console.error('Error loading new flavor:', error);
      }
    });
  }

  function updateProductContent(newDoc) {
    // Get new product info attributes
    const newProductInfo = newDoc.querySelector('product-info');
    const newVendor = newProductInfo?.getAttribute('data-vendor');
    const newHandle = newProductInfo?.getAttribute('data-handle');
    const productType = newProductInfo?.getAttribute('data-product-type');

    const replacements = [
      { selector: '.product__title', type: 'text' },
      { selector: '.product__media-gallery', type: 'html' },
      { selector: '.product__info-container', type: 'html' },
      { selector: 'product-info', type: 'replace' },
      { selector: '.main-product-form', type: 'html' },
      { selector: '.product__description', type: 'html' },
      { selector: '.breadcrumbs--last', type: 'text' },
      { selector: '[id$="__klaviyo_reviews_product_reviews_LyQTD4"]', type: 'html' },
      { selector: 'meta[name="description"]', type: 'attr', attr: 'content' },
      { selector: 'link[rel="canonical"]', type: 'attr', attr: 'href' },
      { selector: 'meta[property="og:title"]', type: 'attr', attr: 'content' },
      { selector: 'meta[property="og:image"]', type: 'attr', attr: 'content' },
      { selector: 'meta[property="og:url"]', type: 'attr', attr: 'content' },
      { selector: '#shopify-section-sticky-atc-bar', type: 'replace' }
    ];

    replacements.forEach(({ selector, type, attr }) => {
      const el = document.querySelector(selector);
      const newEl = newDoc.querySelector(selector);
      if (!el || !newEl) return;
      switch (type) {
        case 'text': el.textContent = newEl.textContent; break;
        case 'html': el.innerHTML = newEl.innerHTML; break;
        case 'attr': el.setAttribute(attr, newEl.getAttribute(attr)); break;
        case 'replace': el.replaceWith(newEl); break;
      }
    });

    const rechargeWidget = document.querySelector('.recharge-subscription-widget');
    if (rechargeWidget) {
      reExecuteScripts(rechargeWidget);
      reRenderWebComponent(rechargeWidget.querySelector('recharge-subscription-widget'));
    }

    reinitializeInteractiveComponents();
    manualInitStickyAtcBar();

    if (newVendor && newHandle && productType && typeof fetchVendorProducts === 'function') {
      fetchVendorProducts(newVendor, newHandle, productType);
    }
  }

  function manualInitStickyAtcBar() {
    const el = document.querySelector('sticky-atc-bar');
    if (!el || el._initialized) return;
    const dataEl = el.querySelector('[type="application/json"]');
    if (!dataEl) return;
    try {
      el.variantData = JSON.parse(dataEl.textContent);
      el._initialized = true;
      if (typeof el.init === 'function') {
        el.productFormActions = document.querySelector('.main-product-form');
        el.mainProductInfo = document.querySelector('product-info');
        el.container = el.closest('.sticky-atc-bar');
        el.init();
      }
    } catch (e) {
      console.error('Sticky ATC error', e);
    }
  }

  function reRenderWebComponent(element) {
    if (!element) return;
    const newEl = element.cloneNode(true);
    element.replaceWith(newEl);
  }

  function reExecuteScripts(container, attrReplace = (attr) => attr.value) {
    const scripts = container.querySelectorAll('script');
    scripts.forEach((oldScript) => {
      const newScript = document.createElement('script');
      for (const attr of oldScript.attributes) {
        newScript.setAttribute(attr.name, attrReplace(attr));
      }
      if (oldScript.textContent) {
        newScript.textContent = oldScript.textContent;
      }
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function reinitializeInteractiveComponents() {

    if (typeof Shopify !== 'undefined' && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    if (typeof initProductMedia === 'function') initProductMedia();
    if (typeof bindProductForm === 'function') bindProductForm();

    const productId = document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
    if (productId && window._klOnsite?.loadReviewsWidget) {
      window._klOnsite.loadReviewsWidget({
        containerSelector: '[id$="__klaviyo_reviews_product_reviews_LyQTD4"]',
        productId: productId
      });
    }

    const addToCartButton = document.querySelector('[id^="ProductSubmitButton-"]');
    const bisTrigger = document.querySelector('.klaviyo-bis-trigger');
    if (addToCartButton?.disabled && bisTrigger) {
      bisTrigger.style.display = 'block';
      document.querySelector('.shopify-payment-button')?.classList.add('hidden');
    }

    if (window.klaviyoBIS?.init) window.klaviyoBIS.init();

    if (typeof attachRechargeListener === 'function') {
      attachRechargeListener();
    }
  }
})();